import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const enginesPlugin = createPlugin({
  id: 'engines',
  routes: {
    root: rootRouteRef,
  },
});

export const EnginesListPage = enginesPlugin.provide(
  createRoutableExtension({
    name: 'EnginesListPage',
    component: () =>
      import('./components/EnginesListComponent').then(m => m.EnginesListComponent),
    mountPoint: rootRouteRef,
  }),
);
